// backend/constants/accountRequestStatuses.js

/**
 * Defines the possible statuses for account requests.
 * This serves as the SINGLE SOURCE OF TRUTH for account request statuses.
 */
const ACCOUNT_REQUEST_STATUSES = {
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
};

module.exports = {
  ACCOUNT_REQUEST_STATUSES,
};